import moment from "moment";

export function formatTime(time: number): string {
  return moment().startOf("day").seconds(time).format("m:ss");
}
